import { createSlice } from '@reduxjs/toolkit';
import reducers from 'src/redux/activity-log/reducers';
import extraReducers from './extra-reducer';
import { initialState } from './types';

const activityLogSlice = createSlice({
  name: 'activityLog',
  initialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  setCurrentSrOrWo,
  addActivityLog,
  clearActivityLog,
  deleteActivityLog,
  patchActivityLog,
  updateActivityLogAttributes,

  setGroupExpansionState,
  addExpandedGroupActivities,

  clearDraft,
  saveDraft,
  updateOriginalNote,
  setAiSummaryOutdated,
} = activityLogSlice.actions;

export default activityLogSlice.reducer;
